import React from "react";
import style from "./Buttons.module.css";
export default function FilledButton(props) {
  const { text, btnClass = "", rightIcon, children, ...restProps } = props;
  return (
    <button className={`${style.filledBtn} ${btnClass}`} {...restProps}>
      {children || text}
      {rightIcon && <span style={{ marginLeft: 8 }}>{rightIcon}</span>}
    </button>
  );
}
